import { render, staticRenderFns } from "./WorkClientOfficesTableItem.vue?vue&type=template&id=9e8e8c32&"
import script from "./WorkClientOfficesTableItem.vue?vue&type=script&lang=js&"
export * from "./WorkClientOfficesTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports